// A destination's own app (task 135) is edited with the App Builder's screens, inside the destination's App section.
export const DESTINATION_APP_PAGE = "app";
export const DESTINATION_APP_SECTIONS = ["entities", "events", "permissions", "schedules"];

const BUILDER_APP_PATH = /^\/studio\/app\/(\d+)(\/.*)?$/;

// destinationOf(appId) → the destination whose own app it is, or 0.
export function toDestinationAppPath(pathname, destinationOf) {
  const match = BUILDER_APP_PATH.exec(pathname || "");
  if (!match) {
    return pathname;
  }
  const destinationId = Number(destinationOf(Number(match[1]))) || 0;
  return destinationId > 0 ? `/build/${destinationId}/${DESTINATION_APP_PAGE}${match[2] ?? ""}` : pathname;
}

export function destinationAppSections(menuItems) {
  return DESTINATION_APP_SECTIONS.map(key => menuItems.find(item => item.key === key)).filter(Boolean);
}

export const APP_SIDEBAR_BUILDER = "builder";
export const APP_SIDEBAR_SECTIONS = "sections";
export const APP_SIDEBAR_NO_APP = "no-app";

export function destinationAppSidebar(customAppId, page) {
  if (!customAppId) {
    return APP_SIDEBAR_NO_APP;
  }
  return page === DESTINATION_APP_PAGE ? APP_SIDEBAR_BUILDER : APP_SIDEBAR_SECTIONS;
}
